import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ThemeProvider } from "../../providers/theme-provider";

export function getContext() {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        retry: (failureCount, error: any) => {
          const status = error?.response?.status;
          // Don't retry on 4xx client errors - these won't succeed on retry
          if (status >= 400 && status < 500) {
            return false;
          }
          // Retry server errors (5xx) and network errors up to 3 times
          return failureCount < 3;
        },
      },
    },
  });
  return {
    queryClient,
  };
}

export function Provider({
  children,
  queryClient,
}: {
  children: React.ReactNode;
  queryClient: QueryClient;
}) {
  return (
    <ThemeProvider>
      <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
    </ThemeProvider>
  );
}
